<div [formGroup]="organizationForm">
  <div class="form-row">
    <mat-form-field>
      <mat-label>Navn</mat-label>
      <input type="text" matInput formControlName="name" />
      @if (organizationForm.controls['name'].hasError('required')) {
        <mat-error>{{ getControlErrorMessage('name', 'required') }}</mat-error>
      }
      @if (organizationForm.controls['name'].hasError('whitespace')) {
        <mat-error>{{ getControlErrorMessage('name', 'empty') }}</mat-error>
      }
      @if (organizationForm.controls['name'].hasError('minlength')) {
        <mat-error>
          {{ getControlErrorMessage('name', 'minLength') }}
        </mat-error>
      }
      @if (organizationForm.controls['name'].hasError('maxlength')) {
        <mat-error>
          {{ getControlErrorMessage('name', 'maxLength') }}
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-row">
    <adm-g4-customer-number [control]="organizationForm.controls.identification" />
  </div>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select formControlName="organizationType" okCustomDropDownArrowDirective>
        @for (enum of organizationType | keyvalue; track enum) {
          <mat-option [value]="enum.key">
            {{ enum.key | translateOrganizationType }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div class="form-row discount">
    <mat-form-field class="discount__type">
      <mat-label>Rabat type</mat-label>
      <mat-select formControlName="discountType" okCustomDropDownArrowDirective>
        @for (discountType of discountTypes; track discountType) {
          <mat-option [value]="discountType.index">
            {{ discountType.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div class="form-row margin--bottom-l">
    <mat-slide-toggle formControlName="idTagInvitationActive" color="primary">
      <div class="flex flex-col">Må oprette brik-brugere</div>
    </mat-slide-toggle>
  </div>
  <div class="form-row organisation-logo-container">
    <div class="help-icon-wrapper">
      <mat-icon
        [matTooltip]="
          'Logoet bliver vist i appen som virksomhedens identitet, på adgangsgrupper og detaljeret visning af lokationer. (Skal være png eller svg. Maks 1MB i størrelse)'
        ">
        help_outline
      </mat-icon>
    </div>
    <mat-form-field>
      <mat-label>Kompakt logo url</mat-label>
      <input type="text" matInput formControlName="compactLogoLink" />
      @if (organizationForm.controls['compactLogoLink'].hasError('pattern')) {
        <mat-error>
          {{ getControlErrorMessage('compactLogoLink', 'pattern') }}
        </mat-error>
      }
    </mat-form-field>
    <div
      class="logo-image-container"
      [matTooltip]="'Intet logo valgt'"
      [matTooltipDisabled]="
        !organizationForm.controls['compactLogoLink'].hasError('pattern') && !!organizationForm.controls['compactLogoLink'].value
      ">
      @if (!organizationForm.controls['compactLogoLink'].hasError('pattern') && !!organizationForm.controls['compactLogoLink'].value) {
        <img class="organization-logo logo-image" [src]="organizationForm.controls['compactLogoLink'].value" />
      } @else {
        <mat-icon class="placeholder-icon">block</mat-icon>
      }
    </div>
  </div>
  <div class="form-row organisation-logo-container">
    <div class="help-icon-wrapper">
      <mat-icon
        [matTooltip]="'Logoet vises på kortet i appen, som pin for lokationens placering. (Skal være png eller svg. Maks 1MB i størrelse)'">
        help_outline
      </mat-icon>
    </div>
    <mat-form-field>
      <mat-label>Logo url</mat-label>
      <input type="text" matInput formControlName="logoLink" />
      @if (organizationForm.controls['logoLink'].hasError('pattern')) {
        <mat-error>
          {{ getControlErrorMessage('logoLink', 'pattern') }}
        </mat-error>
      }
    </mat-form-field>
    <div
      class="logo-image-container"
      [matTooltip]="'Intet logo valgt'"
      [matTooltipDisabled]="!organizationForm.controls['logoLink'].hasError('pattern') && !!organizationForm.controls['logoLink'].value">
      @if (!organizationForm.controls['logoLink'].hasError('pattern') && !!organizationForm.controls['logoLink'].value) {
        <img class="organization-logo logo-image" [src]="organizationForm.controls['logoLink'].value" />
      } @else {
        <mat-icon class="placeholder-icon">block</mat-icon>
      }
    </div>
  </div>

  <button (click)="save()" mat-raised-button color="primary" [disabled]="!organizationForm.valid">Opret afdelinger</button>
</div>
